import React from 'react';

import { Spaced, Title } from '../common/container/Container.jsx';
import { ListArtworkAdd } from '../common/container/Popup.jsx';
import {
  Artwork as ArtworkSlider,
  Artists as ArtistsSlider,
  Galleries as GalleriesSlider,
  Shows as ShowsSlider,
  Slider,
  withConfig as withSliderConfig,
} from '../common/container/Slider.jsx';
import { CitySlide } from '../common/container/Cell.jsx';
import { LinkButton } from '../common/input/Button.jsx';
import Arrows from '../common/input/Arrows.jsx';
import { Genre } from '../common/repository/Type.jsx';

let _IndexInst;
class Index extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      galleryType: 'featured',
      q: '',
    };

    this.showSliderConfig = {
      items: 2,
      loop: true,
      margin: 16.67,
      nav: true,
      navText: ['', ''],
      responsive: {
        // breakpoint from 0 up
        0: {
          items: 1,
          slideBy: 1,
        },
        // breakpoint from 768 up
        768: {
          items: 2,
          slideBy: 2,
        },
      },
      rewindNav: true,
    };

    this._handleSearchInputRef = this._handleSearchInputRef.bind(this);
    this.handleArtworkLikeChange = this.handleArtworkLikeChange.bind(this);
    this.handleCitiesSliderConfig = this.handleCitiesSliderConfig.bind(this);
    this.handleGenreChange = this.handleGenreChange.bind(this);
    this.handleListArtworkAddModalClose =
      this.handleListArtworkAddModalClose.bind(this);
    this.handleParseCitiesResponseData =
      this.handleParseCitiesResponseData.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchBlur = this.handleSearchBlur.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchFocus = this.handleSearchFocus.bind(this);
    this.handleSearchRedirect = this.handleSearchRedirect.bind(this);

    this.citiesSlider = withSliderConfig(Slider);
  }

  componentDidMount() {
    _IndexInst = true;

    if (this.searchInputRef) {
      this.searchInputRef.focus();
    }
    this._handleSearch = _.debounce(this.handleSearch, 250);
  }

  componentWillUnmount() {
    _IndexInst = undefined;

    if (this.artistsRequest) {
      this.artistsRequest.abort();
      this.artistsRequest = null;
    }
    if (this.searchRequest) {
      this.searchRequest.abort();
      this.searchRequest = null;
    }
  }

  _handleSearchInputRef(ref) {
    this.searchInputRef = ref;
  }

  handleArtworkLikeChange(d) {
    if (!_IndexInst) {
      return;
    }
    this.setState({
      listArtworkAddModal: {
        data: d,
        visible: true,
      },
    });
  }

  handleCitiesSliderConfig() {
    return {
      items: 3,
      loop: true,
      margin: 16.67,
      nav: true,
      navText: ['', ''],
      responsive: {
        // breakpoint from 0 up
        0: {
          items: 1,
          slideBy: 1,
        },
        // breakpoint from 768 up
        768: {
          items: 3,
          slideBy: 3,
        },
      },
      rewindNav: true,
    };
  }

  handleGenreChange(galleryType, genre) {
    if (this.state.genre == genre) {
      return;
    }
    this.setState({
      galleryType: galleryType,
      genre: genre,
    });
  }

  handleListArtworkAddModalClose() {
    this.setState({
      listArtworkAddModal: undefined,
    });
  }

  handleParseCitiesResponseData(responseData) {
    const data = responseData.Data;
    data.forEach(function (d) {
      if (d.Image) {
        d.ImgSrc = Artcloud.cdn.url(d.Image.S3Id, 375, 300, 'c_fill');
      }
    });

    // Randomize
    for (let i = data.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = data[i];
      data[i] = data[j];
      data[j] = temp;
    }
    return data;
  }

  handleSearch() {
    const component = this;
    if (component.searchRequest) {
      component.searchRequest.abort();
      component.searchRequest = null;
    }
    if (!component.state.q || !component.state.q.length) {
      component.setState({
        searchResults: undefined,
      });
      return;
    }
    component.searchRequest = Artcloud.api.get(
      Artcloud.url.vendor.marketplace.forms.searches.get(),
      { limit: 5, offset: 0, q: component.state.q },
      function (responseData) {
        component.searchRequest = null;

        let result;
        for (let i = 0; i < responseData.Results.length; i++) {
          result = responseData.Results[i];
          if (!result.Type) {
            continue;
          }
          let baseUrl;
          switch (result.Type.Type) {
            case 0:
              baseUrl = 'art';
              break;
            case 1:
              baseUrl = 'artist';
              break;
            case 2: //show
              break;
            case 3: //city
              baseUrl = 'city';
              if (!result.Image) {
                result.Image = {
                  SmallUrl: '../assets/img/backgrounds/atl.jpg',
                };
              }
              break;
            case 4:
              baseUrl = 'gallery';
              break;
          }
          if (baseUrl) {
            result.link = `/${baseUrl}/${result.Object.Slug || result.Id}`;
          }
        }
        component.setState({
          searchResults: responseData,
        });
      },
      function () {
        component.searchRequest = null;
      }
    );
  }

  handleSearchBlur() {
    const component = this;
    setTimeout(function () {
      component.setState({
        searchResults: undefined,
      });
    }, 200);
  }

  handleSearchChange(event) {
    this.setState(
      {
        q: event.currentTarget.value,
      },
      this._handleSearch
    );
  }

  handleSearchFocus() {
    if (this.state.q && this.state.q.length) {
      this.handleSearch();
    }
  }

  handleSearchRedirect(event) {
    if (event) {
      event.preventDefault();
    }
    if (!this.state.q || !this.state.q.length) {
      return;
    }
    window.location = `/search?q=${this.state.q}`;
  }

  render() {
    const genreButtons = [
      <GenreButton
        key="featured"
        active={!this.state.genre}
        display="Featured"
        galleryType="featured"
        onClick={this.handleGenreChange}
      />,
    ];
    for (let id in Genre.values) {
      genreButtons.push(
        <GenreButton
          key={id}
          active={this.state.genre == Genre.values[id].value}
          genre={id}
          onClick={this.handleGenreChange}
        />
      );
    }
    const browseTitleContent = (
      <React.Fragment>
        <Title>
          <h2>Marketplace Artworks</h2>
          <Arrows display="See All" link="/browse" />
        </Title>
        <div className="section__sort">{genreButtons}</div>
      </React.Fragment>
    );
    const cityTitleContent = (
      <Title>
        <h2>Cities</h2>
        <Arrows display="See All" link="/cities" />
      </Title>
    );
    const galleryTitleContent = (
      <Title>
        <h2>Galleries</h2>
        <Arrows display="See All" link="/galleries" />
      </Title>
    );
    const jewelryTitleContent = (
      <Title>
        <h2>Featured Jewelry</h2>
        <Arrows display="See All" link="/jewelry" />
      </Title>
    );
    const showTitleContent = (
      <Title>
        <h2>Featured Exhibitions</h2>
        <Arrows display="See All" link="/shows" />
      </Title>
    );
    return (
      <React.Fragment>
        <div className="section section--browse" style={{ paddingTop: '40px' }}>
          <ArtworkSlider
            id="browse"
            q={{
              galleryType: this.state.galleryType,
              genre: this.state.genre,
              limit: 30,
              offset: 0,
              type: 'Artwork'
            }}
            slideProps={{
              height: 250,
              onLikeChange: this.handleArtworkLikeChange,
            }}
            titleContent={browseTitleContent}
            url={Artcloud.url.vendor.marketplace.art.get()}
          />
        </div>
        <div className="section section--shows">
          <ShowsSlider
            config={this.showSliderConfig}
            id="shows"
            q={{ limit: 10, offset: 0, type: 0, when: 1 }}
            slideProps={{
              autoCenterFace: true,
              height: 250,
              setWidth: false,
              index: 4,
            }}
            titleContent={showTitleContent}
            url={Artcloud.url.vendor.marketplace.shows.get()}
          />
        </div>
        <div className="section section--browse">
          <ArtworkSlider
            id="browse"
            q={{
              galleryType: 'featured',
              limit: 30,
              offset: 0,
              type: 'Jewelry'
            }}
            slideProps={{
              height: 250,
              onLikeChange: this.handleArtworkLikeChange,
            }}
            titleContent={jewelryTitleContent}
            url={Artcloud.url.vendor.marketplace.art.get()}
          />
        </div>
        <div className="section section--gallery">
          <GalleriesSlider
            id="galleries"
            q={{ limit: 30, offset: 0, type: 0 }}
            slideProps={{ height: 250, setWidth: false, index: 5 }}
            titleContent={galleryTitleContent}
            url={Artcloud.url.vendor.marketplace.galleries.get()}
          />
        </div>
        <div className="section section--artists">
          <Spaced>
            <Title>
              <h2>Artists</h2>
              <Arrows display="See All" link="/artists" />
            </Title>
            <div className="container--spaced__row">
              <div className="grid grid--12">
                <ArtistsSlider
                  q={{ limit: 30, offset: 0, order: 'density' }}
                  slideProps={{ height: 250, setWidth: false, index: 5 }}
                  sliderClassName="slider--grid-2"
                  url={Artcloud.url.vendor.marketplace.artists.get()}
                />
              </div>
            </div>
          </Spaced>
        </div>

        <div className="section section--cities">
          <this.citiesSlider
            id="citiesSlider"
            slideComponent={CitySlide}
            slideProps={{ height: 300, setWidth: false, index: 5 }}
            sliderClassName="slider--city"
            titleContent={cityTitleContent}
            url={Artcloud.url.vendor.marketplace.cities.get()}
            onConfig={this.handleCitiesSliderConfig}
            onParseResults={this.handleParseCitiesResponseData}
          />
        </div>

        {this.state.listArtworkAddModal &&
          this.state.listArtworkAddModal.visible && (
            <ListArtworkAdd
              data={this.state.listArtworkAddModal.data}
              onClose={this.handleListArtworkAddModalClose}
            />
          )}
      </React.Fragment>
    );
  }
}

function CallToAction(props) {
  return (
    <div className="grid grid--4">
      <div className="cta__box">
        <img alt="" className="cta__icon" src={props.image} />
        <h3>{props.title}</h3>
        <p>{props.content}</p>
        <Arrows display={props.linkDisplay} link={props.link} />
      </div>
    </div>
  );
}

class GenreButton extends React.Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(event) {
    if (event) {
      event.preventDefault();
    }
    const genre = Genre.values[this.props.genre];
    this.props.onClick(this.props.galleryType, genre ? genre.value : undefined);
  }

  render() {
    const display =
      this.props.display || Genre.values[this.props.genre].display;
    return (
      <LinkButton
        config={{
          active: this.props.active ? 'active' : undefined,
          color: 'light',
          style: 'outline',
        }}
        onClick={this.handleClick}
      >
        {display}
      </LinkButton>
    );
  }
}

function SearchResult(props) {
  const d = props.d || {};
  return (
    <a href={d.link} className="search__item">
      <div
        className="search__item__img"
        style={{
          backgroundImage: d.Image ? `url('${d.Image.SmallUrl}')` : undefined,
        }}
      />
      <div className="search__item__content">
        <div className="search__item__label">{d.Type && d.Type.Name}</div>
        <div className="search__item__title">{d.Result}</div>
      </div>
    </a>
  );
}

export default Index;
